<template>
    <b-row>
        <!-- Fornecedores -->
        <pagamentos-dash
            :qtd="qtdPagamentosProgramados"
            :loading="loading"
            :rota="{ name: 'FornecedoresPagamentos' }"
            v-if="$temAcessoView('GEST-FORNECEDORES-01')"
        ></pagamentos-dash>
        <contratos-dash
            v-if="$temAcessoView('GEST-FORNECEDORES-01')"
            :rota="{ name: 'FornecedoresContratos' }"
        ></contratos-dash>
        <dados-cadastrais-dash
            v-if="$temAcessoView('GEST-FORNECEDORES-01')"
            :rota="{ name: 'FornecedoresDadosCadastrais' }"
        ></dados-cadastrais-dash>
        <fornecedores-dirfs-dash
            v-if="$temAcessoView('GEST-FORNECEDORES-01')"
            :rota="{ name: 'FornecedoresDirfs' }"
        ></fornecedores-dirfs-dash>
        <certidoes-dash
            v-if="$temAcessoView('GEST-FORNECEDORES-01')"
            :rota="{ name: 'FornecedoresCertidoes' }"
        ></certidoes-dash>
        <usuarios-dash
            v-if="$temAcessoView('GEST-FORNECEDORES-02')"
            rota="UsuariosFornecedor"
        ></usuarios-dash>
        <total-acessos
            v-if="$temAcessoView('GEST-FORNECEDORES-01')"
            :qtd="qtdTotalAcessos"
        ></total-acessos>
        <total-acessos-ano
            v-if="$temAcessoView('GEST-FORNECEDORES-01')"
            :qtd="qtdTotalAcessosAno"
        ></total-acessos-ano>
        <total-acessos-mes
            v-if="$temAcessoView('GEST-FORNECEDORES-01')"
            :qtd="qtdTotalAcessosMes"
        ></total-acessos-mes>
    </b-row>
</template>

<script>
import FornecedoresServicos from './FornecedoresServicos'
// Fornecedores
import PagamentosDash from './../fornecedor/pagamentos/PagamentosDash'
import DadosCadastraisDash from './../fornecedor/dadoscadastrais/DadosCadastraisDash'
import FornecedoresDirfsDash from './../fornecedor/dirfs/DirfsDash'
import ContratosDash from './../fornecedor/contratos/ContratosDash'
import CertidoesDash from './../fornecedor/certidoes/CertidoesDash'
import TotalAcessos from './../ctrlacesso/login/TotalAcessosDash'
import TotalAcessosAno from './../ctrlacesso/login/TotalAcessosAnoDash'
import TotalAcessosMes from './../ctrlacesso/login/TotalAcessosMesDash'
import UsuariosDash from '../ctrlacesso/usuarios/UsuariosDash'

export default {
    props: {
        fornecedorId: {
            type: String,
            default: () => ''
        }
    },

    components: {
        PagamentosDash,
        DadosCadastraisDash,
        FornecedoresDirfsDash,
        ContratosDash,
        CertidoesDash,
        TotalAcessos,
        TotalAcessosAno,
        TotalAcessosMes,
        UsuariosDash
    },

    data() {
        return {
            loading: false,
            qtdPagamentosProgramados: 0,
            qtdTotalAcessos: 0,
            qtdTotalAcessosAno: 0,
            qtdTotalAcessosMes: 0
        }
    },

    methods: {
        obterDashboard() {
            if (this.fornecedorId && this.fornecedorId != '') {
                this.loading = true
                FornecedoresServicos.obterDashboard(this.fornecedorId).then(
                    (response) => {
                        if (response) {
                            if (response.success) {
                                this.qtdPagamentosProgramados =
                                    response.data.QtdPagamentosProgramados
                                this.qtdTotalAcessos =
                                    response.data.QtdTotalAcessos
                                this.qtdTotalAcessosAno =
                                    response.data.QtdTotalAcessosAno
                                this.qtdTotalAcessosMes =
                                    response.data.QtdTotalAcessosMes
                                this.$emit(
                                    'atualizarFornecedor',
                                    response.data.UltimoAcesso
                                )
                            }
                        }
                        this.loading = false
                    }
                )
            }
        }
    },

    created() {
        this.obterDashboard()
    },

    watch: {
        fornecedorId() {
            this.obterDashboard()
        }
    }
}
</script>
